export function newPlanLogbookDTO(loginData, plan) {
    const logbook = {
        logBookType: 'PLAN',
        logBookId: 0,
        logBookOrganizationUUID: loginData.loggedOrganizationUuid,
        logBookOwnerUUID: loginData.userUuid,
        logBookEnabled: true,
        logBookProtected: false,
        folders: [],
        items: [],
        whitelistUsers: [],
        planUUID: plan.planUUID,
    };
    return logbook;
}

export function newAreaLogbookDTO(loginData, area) {
    const logbook = {
        logBookType: 'AREA',
        logBookId: 0,
        logBookOrganizationUUID: loginData.loggedOrganizationUuid,
        logBookOwnerUUID: loginData.userUuid,
        logBookEnabled: true,
        logBookProtected: false,
        folders: [],
        items: [],
        whitelistUsers: [],
        areaId: area.areaId,
        planUUID: area.plan.planUUID,
    };
    return logbook;
}

export function newAreaIndicatorLogbookDTO(loginData, areaIndicator) {
    const logbook = {
        logBookType: 'AREA_INDICATOR',
        logBookId: 0,
        logBookOrganizationUUID: loginData.loggedOrganizationUuid,
        logBookOwnerUUID: loginData.userUuid,
        logBookEnabled: true,
        logBookProtected: false,
        folders: [],
        items: [],
        whitelistUsers: [],
        areaIndicatorId: areaIndicator.areaIndicatorId,
        areaId: areaIndicator.area.areaId,
        planUUID: areaIndicator.area.plan.planUUID,
    };
    return logbook;
}